import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment.development';
import { JwtToken, GetUsersResponseType, Farm, Employee, Product, GetSubscribersResponseType, GetAllMessagesResponseType, GetReviewsResponseType, Message } from '../../models/types';
import { jwtDecode } from 'jwt-decode'; // Ensure this import is correct
import { LoginService } from './login.service';
import { MessageDetailsComponentComponent } from '../components/message-details-component/message-details-component.component';

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

  weatherApiUrl = 'https://opendata.si/vreme/report/';

  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) { }

  getFarmSubscribers(farmID: number): Observable<GetSubscribersResponseType> {
    return this.http.get<GetSubscribersResponseType>(`${environment.statistics}/farm/${farmID}/subscribers`);
  }

  getAllMessages(farmID: number): Observable<GetAllMessagesResponseType> {
    return this.http.get<GetAllMessagesResponseType>(`${environment.statistics}/farm/${farmID}/messages`);
  }

  getAllReviews(farmID: number): Observable<GetReviewsResponseType> {
    return this.http.get<GetReviewsResponseType>(`${environment.statistics}/farm/${farmID}/reviews`);
  }

  getWeather(lat: number, lon: number): Observable<any> {
    const params = new HttpParams()
      .set('lat', lat.toString())
      .set('lon', lon.toString());

    return this.http.get<any>(this.weatherApiUrl, { params });
  }
}
